// Web Bluetooth ESC/POS thermal printer driver
// Works with common 58mm/80mm Bluetooth thermal printers (e.g., RPP02N, MTP-3, generic ESC/POS)

const PRINTER_SERVICE = "000018f0-0000-1000-8000-00805f9b34fb"; // common Nordic UART-like
const PRINTER_CHAR = "00002af1-0000-1000-8000-00805f9b34fb";

const ESC = 0x1b;
const GS = 0x1d;

// ESC/POS commands
const CMD = {
  INIT: [ESC, 0x40],
  ALIGN_LEFT: [ESC, 0x61, 0],
  ALIGN_CENTER: [ESC, 0x61, 1],
  ALIGN_RIGHT: [ESC, 0x61, 2],
  BOLD_ON: [ESC, 0x45, 1],
  BOLD_OFF: [ESC, 0x45, 0],
  DOUBLE_ON: [GS, 0x21, 0x11],
  DOUBLE_OFF: [GS, 0x21, 0],
  CUT: [GS, 0x56, 0x00],
  LF: [0x0a],
};

const encode = (text) => new TextEncoder().encode(text);

function* chunks(arr, size) {
  for (let i = 0; i < arr.length; i += size) yield arr.slice(i, i + size);
}

async function sendBytes(characteristic, bytes) {
  // Bluetooth LE has small MTU; chunk at 100 bytes
  for (const chunk of chunks(Array.from(bytes), 100)) {
    await characteristic.writeValueWithoutResponse(new Uint8Array(chunk));
  }
}

function build(sale, businessName = "EEMAN MEATS") {
  const out = [];
  const push = (arr) => out.push(...arr);
  const text = (s) => push(Array.from(encode(s)));
  const line = (s = "") => text(s + "\n");

  push(CMD.INIT);
  push(CMD.ALIGN_CENTER);
  push(CMD.DOUBLE_ON);
  line(businessName);
  push(CMD.DOUBLE_OFF);
  line(sale.channel === "wholesale" ? "WHOLESALE INVOICE" : "RETAIL BILL");
  line("--------------------------------");
  push(CMD.ALIGN_LEFT);
  const billNo = sale.bill_no ? String(sale.bill_no) : (sale.id || "").slice(0, 8).toUpperCase();
  push(CMD.DOUBLE_ON);
  push(CMD.BOLD_ON);
  line(`BILL NO: ${billNo}`);
  push(CMD.BOLD_OFF);
  push(CMD.DOUBLE_OFF);
  line(`Date: ${sale.date}`);
  if (sale.customer_name) line(`Cust: ${sale.customer_name}`);
  line("--------------------------------");

  for (const it of sale.items) {
    const qty = it.unit === "piece" ? `${Math.round(it.kg)} pc` : `${Number(it.kg).toFixed(3)} kg`;
    line(it.product_name);
    const left = ` ${qty} x ${Number(it.rate).toFixed(2)}`;
    const right = ` ${Number(it.amount).toFixed(2)}`;
    const padding = Math.max(1, 32 - left.length - right.length);
    line(left + " ".repeat(padding) + right);
  }
  line("--------------------------------");
  push(CMD.BOLD_ON);
  push(CMD.ALIGN_RIGHT);
  line(`TOTAL: Rs ${Number(sale.total_amount).toFixed(2)}`);
  push(CMD.BOLD_OFF);
  push(CMD.ALIGN_LEFT);
  if (sale.paid_amount > 0) line(`Paid:  Rs ${Number(sale.paid_amount).toFixed(2)}`);
  if (sale.paid_amount && sale.paid_amount < sale.total_amount) {
    line(`Bal:   Rs ${(sale.total_amount - sale.paid_amount).toFixed(2)}`);
  }
  line("");
  push(CMD.ALIGN_CENTER);
  line("Thank you · visit again");
  line("");
  line("");
  line("");
  push(CMD.CUT);

  return new Uint8Array(out);
}

let _device = null;
let _char = null;

export async function pairPrinter() {
  if (!("bluetooth" in navigator)) {
    throw new Error("Web Bluetooth not supported in this browser. Use Chrome on Android or desktop.");
  }
  _device = await navigator.bluetooth.requestDevice({
    acceptAllDevices: true,
    optionalServices: [PRINTER_SERVICE, "0000180f-0000-1000-8000-00805f9b34fb"],
  });
  const server = await _device.gatt.connect();
  // try common service first, otherwise enumerate
  let service;
  try {
    service = await server.getPrimaryService(PRINTER_SERVICE);
  } catch {
    const services = await server.getPrimaryServices();
    service = services.find((s) => s.uuid !== "0000180f-0000-1000-8000-00805f9b34fb") || services[0];
  }
  const chars = await service.getCharacteristics();
  _char = chars.find((c) => c.properties.writeWithoutResponse || c.properties.write);
  if (!_char) throw new Error("No writable characteristic found on this printer");
  localStorage.setItem("eeman_printer_name", _device.name || "Bluetooth Printer");
  return _device.name || "Bluetooth Printer";
}

export function getSavedPrinter() {
  return localStorage.getItem("eeman_printer_name") || "";
}

export async function printBill(sale, businessName = "EEMAN MEATS") {
  if (!_char) {
    await pairPrinter();
  }
  if (!_device.gatt.connected) {
    await _device.gatt.connect();
  }
  const data = build(sale, businessName);
  await sendBytes(_char, data);
}
